import { useBreakpointValue } from '@ecoinvent/ui';

const useTourAvailable = () => useBreakpointValue({ base: false, lg: true }) ?? false;

export default useTourAvailable;
